<template>
  <Page class="page-witnesses">
    <h1>{{ $t('witnessesTitle') }}</h1>

    <template v-for="(item, index) in $t('witnessesPreamble.content').slice(0)">
      <p :key="`paragraph-${index}`" v-html="item" />
    </template>

    <div class="library-works" v-if="works">
      <div class="work" v-for="authorSlug in authorSlugs" :key="authorSlug">
        <AuthorBio :author-slug="authorSlug" />
        <div class="links">
          <RedButton :full-width="true" :to="{name: 'reader', query: { urn: readUrl(authorSlug), source: sourcesRouteName }}">{{ $t('readButton') }}</RedButton>
          <RedButton :full-width="true" :to="{name: 'external', query: { next: downloadUrl(authorSlug)} }">{{ $t('downloadTEIXML') }}</RedButton>
        </div>
      </div>
    </div>
    <LoaderBall v-else />
  </Page>
</template>

<script>
  import AuthorBio from '../components/AuthorBio.vue';
  import { SOURCES_ROUTE_NAME, WORK_SLUG_URN_LOOKUP } from '../constants';
  import Page from '../components/Page.vue';
  import LoaderBall from '../components/LoaderBall.vue';
  import RedButton from './home/RedButton.vue';

  export default {
    components: {
      AuthorBio,
      LoaderBall,
      Page,
      RedButton,
    },
    computed: {
      gqlQuery() {
        return `{
          works {
            edges {
              cursor
              node {
                id
                urn
                name
                metadata
                teiXmlUrl
                superheadings {
                  edges {
                    node {
                      id
                      title
                      sections (first: 1) {
                        edges {
                          node {
                            idx
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }`;
      },
      works() {
        return this.gqlData && this.gqlData.works && this.gqlData.works.edges.map((e) => {
          const {
            id, urn, name, metadata, superheadings, teiXmlUrl,
          } = e.node;
          return {
            id,
            urn,
            name,
            metadata,
            teiXmlUrl,
            superheadings: superheadings.edges.map((_e) => {
              const { _id, title, sections } = _e.node;
              return {
                id: _id,
                title,
                firstSectionIdx: sections.edges[0].node.idx,
              };
            }),
          };
        });
      },
      sourcesRouteName() {
        return SOURCES_ROUTE_NAME;
      },
      authorSlugs() {
        return Object.keys(WORK_SLUG_URN_LOOKUP);
      },
      baseUrl() {
        return this.atlasEndpoint.split('/graphql')[0];
      },
    },
    methods: {
      downloadUrl(authorSlug) {
        const urn = WORK_SLUG_URN_LOOKUP[authorSlug];
        if (this.gqlData) {
          const path = this.works.filter(work => work.urn === urn)[0].teiXmlUrl;
          return `${this.baseUrl}${path}`;
        }
        return null;
      },
      readUrl(authorSlug) {
        const urn = WORK_SLUG_URN_LOOKUP[authorSlug];
        if (this.gqlData) {
          const sectionIdx = this.works.filter(work => work.urn === urn)[0].superheadings[0].firstSectionIdx;
          return `${urn}:${sectionIdx}`;
        }
        return null;
      },
    },
  };
</script>


<style lang="scss">
  @import '../variables';
  #app[data-locale="ar"] .page-witnesses {
    direction: rtl;
    font-family: $ar-font-family;
    font-size: $ar-default-font-size;
  }
  .page-witnesses .library-works {
    display: flex;
    justify-content: space-between;

    .work {
      flex: 1;
      margin: 10px;
      border: 1px solid #ccc;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .metadata {
        .work-header {
          h3 {
            font-size: 1.17em;
            line-height: 1.3;
          }
          h2 {
            font-size: 1.5em;
            line-height: 1.4;
          }
          margin: -5px -10px 0;
          padding: 10px;
          background: $white url(../assets/images/slider-bg-pattern.png) center center no-repeat;
        }
        padding: 5px 10px;
        h2,
        h3,
        h4 {
          margin: 0;
        }
        h3 {
          color: #777;
          font-weight: 400;
        }
        h4 {
          font-size: 0.825em;
          color: #777;
          font-weight: 400;
        }
        p {
          font-size: 0.8em;
          color: #444;
        }
        h2 {
          color: $brand;
        }
      }
      .links a {
        text-align: center;
        padding: 10px;
        margin: 5px;
        display: block;
        width: inherit;
      }
      .read-more-bio {
        margin-bottom: 1.0em;
        font-size: 0.8em;
        font-style: italic;
        color: $brand;
        display: block;
        &:hover {
          color: $gray-600;
        }
      }
    }
  }
</style>
